export default (ex, context) => {
  console.error(ex, context);
};
